import { MESSAGES } from '../../constants';
import { TItem } from '../reducers/types';

export function needMarkMessageAsUnread(message?: TItem): boolean {
  switch (message?.type) {
    case undefined:
    case MESSAGES.BOT_TYPING:
    case MESSAGES.USER_MESSAGE:
    case MESSAGES.WAITING_FOR_AGENT:
    case MESSAGES.CHANGE_MODE:
    case MESSAGES.AGENT_STATUS:
    case MESSAGES.CHAT_TRANSFERRED:
      return false;
    case MESSAGES.BUTTONS:
    case MESSAGES.BUTTONS_VERTICAL:
      return message.items.length > 0;
    default:
      return true;
  }
}
